<template>
  <b-card no-body :id="'widgetppt' + widget.id">
    <div class="card-header" :class="{fixedCardHeader: isOverflown}">
      <span v-b-tooltip.hover :title="title" class="widget-title">{{title}}</span>
      <settings-button />
      <filters-button :filters="this.widget.filters" v-if="this.widget.filters.length > 0"></filters-button>
    </div>
    <b-card-body class='p-3 clearfix' @click="handleClickThrough">
      <h5 class="loading-text" v-show="!goodChart">Unable To Load Data</h5>
      <line-chart ref=chart v-show="goodChart"/>
    </b-card-body>
    <div class="comparison-disclaimer" v-if="this.widget.disableDataComparison"><sup>*</sup>Data comparison unavailable</div>
  </b-card>
</template>

<script>
import LineChart from '@/views/charts/LineChart'
import FiltersButton from '@/views/buttons/FiltersButton'
import { base_widget } from '@/views/widgets/base_widget'

export default {
  mixins: [base_widget],
  components: {
    LineChart,
    FiltersButton
  },

  data () {
    return {
      colors: [
                'transparent'
              ],
      goodChart: true
    }
  },

  mounted () {
    this.changeChartId()
  },

  computed: {
    borderColor () {
      return this.colorsArray
    }
  },

  methods: {
    setData (response) {
      var chart = this.$refs.chart
      var data = response.data.data
      var multiYAxis = data.multi_y_axis
      let datasets = this.setDatasets(data, multiYAxis)
      let tooltipLabels = this.setTooltipsLabels(response.data)
      chart.disableDataComparison = this.widget.disableDataComparison
      let labels =  this.setLabels(data)
      if (labels.length > 0) {
        this.goodChart = true
        chart.labels = labels
        chart.datasets = datasets
        chart.tooltipLabels = tooltipLabels
        chart.multiYAxis = multiYAxis
        chart.disableLegend = this.widget.disableLegend
        chart.createChart()
        this.saveWidgetData(datasets.map( (set) => set.data), labels)
      } else {
        this.goodChart = false
        this.saveWidgetData({}, [])
      }
    },

    changeChartId () {
      var item = document.getElementById('line-chart')
      item.id = 'line-chart-' + this.widget.id
    }

  }

}
</script>

<style scoped>
  .loading-text {
    color: #757575;
    text-align: center;
    margin-top: 10px;
    text-transform: uppercase;
    font-family: 'Cooper Hewitt Semibold';
    letter-spacing: 3px;
  }
  .card-body > div {
    position: relative;
  }
</style>
